import { ColumnDef, SortingState, Updater } from "@tanstack/react-table"
import { cn } from "lib/utils"
import { GenericResource } from "models/generic"
import React from "react"
import { Link } from "react-router-dom"

export interface GridTableProps<T extends GenericResource> {
  columns: ColumnDef<T>[]
  data: T[]
  fetchNextPage: () => void
  isFetching: boolean
  isFetchingNextPage?: boolean
  isLoading: boolean
  totalCount: number
  windowMode?: boolean
  transparentHeader?: boolean
  onClickRow?: (row: T) => void
  className?: string
  local?: boolean
  isFiltering?: boolean
  onSaveNewPositions?: (newPositions: T[]) => void
  children?: React.ReactNode
  overscan?: number
  rowHeight?: number
  routeBase?: string

  // If paginated
  sorting?: SortingState
  onSortChange?: (sortState: Updater<SortingState>) => void
  layout?: "static" | "default" | "grid"
  gridElement?: React.ComponentType<{ item: T; index: number }>
  tableActionsColumn?: ColumnDef<T>
}

function GridTable<T extends GenericResource>(props: GridTableProps<T>) {
  const GridElement = props.gridElement

  const mockData = Array.from({ length: 5 }).map((_, index) => ({
    id: `mock-${index}`,
  }))

  return (
    // <div className="overflow-auto h-[calc(var(--app-container-height)-128px)]">
    <div className="flex justify-center">
      {/* <div className={"grid md:!grid-cols-2 lg:!grid-cols-3 xl:!grid-cols-4 2xl:!grid-cols-5 gap-5 p-[30px] g_grid_table max-w-[1048px]"}> */}
      <div className={"grid md:!grid-cols-2 lg:!grid-cols-3 xl:!grid-cols-4 gap-5 p-[30px] g_grid_table max-w-[var(--mid)] w-full"}>
        {/* <div className={"grid !grid-cols-4 gap-5 p-[30px] g_grid_table"}> */}
        <Link
          to={`${props.routeBase}/new`}
          className={cn(
            // "flex-col gap-3 p-5 rounded-2xl border border-solid transition-all duration-200 border-selected-active-more bg-base-100 fc h-[180px]",
            "flex-col gap-3 p-5 rounded-2xl border-2 border-dashed transition-all duration-200 border-selected-active fc h-[150px]",
            // "hover:shadow-lg hover:translate-y-[-2px] hover:border-blue-500 hover:bg-blue-500/5 group",
            "hover:bg-selected-lighter-more hover:border-selected-active-more group",
          )}
        >
          <IconIcBaselineAddCircle className="opacity-90 text-content-100 group-hover:opacity-100 size-8" />
          <h2 className="text-sm">Criar agente</h2>
        </Link>
        {props.data.map((item, index) =>
          GridElement ? (
            <GridElement key={item.id} item={item} index={index} columns={props.columns} tableActionsColumn={props.tableActionsColumn} />
          ) : null,
        )}
        {props.isFetching &&
          mockData.map((item, index) =>
            GridElement ? (
              <GridElement
                key={item.id}
                item={item as any}
                index={index}
                columns={props.columns}
                tableActionsColumn={props.tableActionsColumn}
                loading
              />
            ) : null,
          )}
      </div>
    </div>
  )
}

export default GridTable
